import { EditorialToolsService } from './editorialToolsService';
interface LatestIssueResponse {
  issue: string;
  number: string;
  url: string;
  title: string;
  cover: string;
  cover_url?: string; // Optional für Backward-Kompatibilität
}

class SocialMediaService {

  async getLatestIssue(): Promise<LatestIssueResponse> {
    try {
      const data = await EditorialToolsService.call<LatestIssueResponse>('/issues/latest');
      return data;
    } catch (error) {
      console.error('Fehler beim Laden der neuesten Ausgabe:', error);
      throw new Error('Fehler beim Laden der neuesten Ausgabe');
    }
  }
}

export const socialMediaService = new SocialMediaService();
export type { LatestIssueResponse };
